module.exports = __webpack_public_path__ + "img/空白（居中页码+插图）.d5032786.jpg";